import React, { useState } from 'react'
import Select from 'react-select'
import { Drawer, Checkbox } from 'antd'

import { useListData, usePet } from '../../modules'

import Receive from '../reusable/receive'
import Confirm from '../reusable/confirm'

const purposeCopy = {
    item: {
        title: 'Billing & Inventory Group',
        description: 'Controls billing categorization for these items, and which store they are dispensed from by default. Assign a sale item to this group from the sale item’s own edit screen.',
    },
    routing: {
        title: 'Department Queue',
        description: 'Controls which department’s queue an order appears in, and who gets notified when a new patient arrives. Assign a sale item to this group from the sale item’s own edit screen.',
    },
}

const EditGroup = ({ toggle, visible, group, purpose = 'item', onPerform }) => {
    const isEdit = !!group?._id
    const copy = purposeCopy[purpose] ?? purposeCopy.item

    const [name, setName] = useState(group?.name ?? '')
    const [defaultStore, setDefaultStore] = useState(group?.defaultStore ? { label: group.defaultStore.name, value: group.defaultStore._id } : null)
    const [hidden, setHidden] = useState(!!group?.hidden)

    const [, { list: stores = [] }] = useListData('stores', { order: 1 }, { notify: purpose === 'item' }, 'stores', 100)

    const storeOptions = stores.map(store => ({ label: store.name, value: store._id }))

    const onComplete = ({ }, notif, ops) => {
        notif('Group has been saved', ops('success'))
        onPerform()
        setTimeout(toggle, 300)
    }

    const [{ loading: newLoading }, createGroup] = usePet(purpose === 'item' ? 'newItemGroup' : 'newRoutingGroup', {
        name,
        ...(purpose === 'item' ? { defaultStore: defaultStore?.value } : { hidden }),
    }, { notify: true, manual: true, callback: onComplete, load: { msg: 'Creating group...' } })

    const [{ loading: editLoading }, saveGroup] = usePet(purpose === 'item' ? 'editItemGroup' : 'editRoutingGroup', {
        id: group?._id,
        name,
        ...(purpose === 'item' ? { defaultStore: defaultStore?.value ?? null } : { hidden }),
    }, { notify: true, manual: true, callback: onComplete, load: { msg: 'Saving group...' } })

    const save = () => Confirm({
        title: 'Save Changes?',
        message: 'Are you sure you want to save these changes?',
        okText: 'Save Changes',
        onOk: isEdit ? saveGroup : createGroup,
    })

    return (
        <Drawer
            closable
            width={480}
            onClose={toggle}
            visible={visible}
            title={`${isEdit ? 'Edit' : 'New'} ${copy.title}`}>
            <p className="text-xs text-gray-500 mb-4">{copy.description}</p>
            <div className="flex flex-wrap -mx-3 mb-3">
                <div className="w-full px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Name</label>
                    <input
                        value={name}
                        onChange={e => setName(e.target.value)}
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        placeholder="e.g. Medication" />
                </div>
            </div>
            {
                purpose === 'item' &&
                <div className="flex flex-wrap -mx-3 mb-3">
                    <div className="w-full px-3">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            Default Store
                        </label>
                        <p className="text-xs text-gray-500 mb-2">Items in this group are dispensed/debited from this store by default.</p>
                        <Receive>
                            <Select
                                isClearable
                                value={defaultStore}
                                onChange={setDefaultStore}
                                options={storeOptions}
                                placeholder="No default store" />
                        </Receive>
                    </div>
                </div>
            }
            {
                purpose === 'routing' &&
                <div className="flex flex-wrap -mx-3 mb-3">
                    <div className="w-full px-3">
                        <Checkbox checked={hidden} onChange={e => setHidden(e.target.checked)}>Hidden from general category pickers</Checkbox>
                    </div>
                </div>
            }
            <div className="flex justify-end mt-4">
                <button
                    onClick={save}
                    disabled={newLoading || editLoading || !name}
                    className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">
                    Save
                </button>
            </div>
        </Drawer>
    )
}

export default EditGroup
